import { BaseRequestsService } from '@/services/base-requests-service';

class LimitsRequests extends BaseRequestsService {

  getUserLimits(options) {
    return this.http.post('v1/limit/user-limits', options);
  }

  getLimitMessage(messageType) {
    return this.http.get(`v1/i18n/translate?key=${messageType}`);
  }

}

const limitRequests = new LimitsRequests();
export { limitRequests as LimitsRequests };
